import type { FlagConfiguration } from '@atlassian/jira-flags';
import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	componentEditionFailedTitle: {
		id: 'project-components.flags.component-edition-failed-title',
		defaultMessage: "We couldn't edit the component",
		description:
			"Flag's title - appears when user couldn't open component's edit modal. For example: user is offline.",
	},
	componentEditionFailedDescription: {
		id: 'project-components.flags.component-edition-failed-description',
		defaultMessage: 'Something went wrong. Try again.',
		description:
			"Flag's description - appears when user couldn't open component's edit modal. For example: user is offline.",
	},
});

const UpdateInitiateError = (): FlagConfiguration => ({
	type: 'error',
	isAutoDismiss: false,
	title: messages.componentEditionFailedTitle,
	description: messages.componentEditionFailedDescription,
	messageId: 'project-directories.components.flags.update.flag.error.initiate-error',
	messageType: 'transactional',
});

export default UpdateInitiateError;
